import onboarding from '@apps-payroll/modules/onboarding/locales/en.json';
import payCalendar from '@apps-payroll/modules/pay-calendar/locales/en.json';
import payrollIntroduce from '@apps-payroll/modules/payroll-introduce/locales/en.json';
import settings from '@apps-payroll/modules/settings/locales/en.json';
import payrollManagerGlobalSettings from '@apps-payroll/modules/payroll-manager-global-settings/locales/en.json';
import common from '@apps-payroll/locales/en.json';
import leaveSettings from '@apps-payroll/modules/leave-settings/locales/en.json';

const combined = {
  common,
  ...payCalendar,
  ...payrollIntroduce,
  ...onboarding,
  ...settings,
  ...leaveSettings,
  ...payrollManagerGlobalSettings,
};

export default combined;
